import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["size"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { getScaleAdjustedSize, getSizeErrorCorrectionFactor, getFontSizeFromDOM } from '../utils/general';

// copy of skeleton.selector.js in twidgets/appSkeleton
var getWorkSpaceSize = function getWorkSpaceSize(state) {
  return _get(state, 'skeleton.workSpaceSize');
};
export var DEFAULT_OPTIONS = {
  hasPageFooter: 0,
  hasPageHeader: 1,
  hasTabSection: 0,
  headerHeight: 64,
  footerHeight: 64,
  tabSectionHeight: 50
};
export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mergedOptions = Object.assign({}, DEFAULT_OPTIONS, options);
  var hasPageFooter = mergedOptions.hasPageFooter,
    hasPageHeader = mergedOptions.hasPageHeader,
    hasTabSection = mergedOptions.hasTabSection,
    headerHeight = mergedOptions.headerHeight,
    footerHeight = mergedOptions.footerHeight,
    tabSectionHeight = mergedOptions.tabSectionHeight;
  return function (WrappedComponent) {
    var WrapperComponent = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(WrapperComponent, _React$PureComponent);
      var _super = _createSuper(WrapperComponent);
      function WrapperComponent() {
        _classCallCheck(this, WrapperComponent);
        return _super.apply(this, arguments);
      }
      _createClass(WrapperComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var displayScale = getFontSizeFromDOM();
          window.pxToRemErrorRate = getSizeErrorCorrectionFactor(displayScale);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          var displayScale = getFontSizeFromDOM();
          window.pxToRemErrorRate = getSizeErrorCorrectionFactor(displayScale);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
            size = _this$props.size,
            rest = _objectWithoutProperties(_this$props, _excluded);
          var _size$contentHeight = size.contentHeight,
            contentHeight = _size$contentHeight === void 0 ? 0 : _size$contentHeight;
          var contentWidth = size.contentWidth;
          if (hasPageHeader) {
            contentHeight -= getScaleAdjustedSize(headerHeight);
          }
          if (hasPageFooter) {
            contentHeight -= getScaleAdjustedSize(footerHeight);
          }
          if (hasTabSection) {
            contentHeight -= getScaleAdjustedSize(tabSectionHeight);
          }
          return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
            contentHeight: contentHeight
          }, rest, {
            contentWidth: contentWidth
          }));
        }
      }]);
      return WrapperComponent;
    }(React.PureComponent);
    _defineProperty(WrapperComponent, "propTypes", {
      size: PropTypes.object.isRequired,
      displayScale: PropTypes.number.isRequired
    });
    return connect(function (state) {
      return {
        size: getWorkSpaceSize(state)
      };
    })(WrapperComponent);
  };
});